<div class="row ">

    <span class="float-right ml-auto" style="margin-right: 85px;">
        <button class="ml-2 btn btn-browse" type="button" (click)="addResources()">Add Resources</button>
    </span>

</div>

<div class="col-md-12 mt-3" *ngIf="resourceDataSource && resourceDataSource.data.length >0">
    <mat-form-field class="float-right">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
    </mat-form-field>
    <!-- Material Table -->
    <table aria-describedby="resources" aria-labelledby="resources" mat-table [dataSource]="resourceDataSource" matSort class="col-md-12 mat-elevation-z8">

        <ng-container matColumnDef="resources.resourceName">
            <th id="resource-url" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Resource Name </th>
            <td mat-cell *matCellDef="let element">
                <a class="resource-name-list-item" [href]='element.resources.resourceUrl' target="_blank">{{element.resources.resourceName}}
                    <span class="fa fa-external-link"></span>
                </a>
            </td>
        </ng-container>

        <ng-container matColumnDef="resources.resourceGroup">
            <th id="resource-group" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Resource Group </th>
            <td mat-cell *matCellDef="let element"> {{element.resources.resourceGroup}} </td>
        </ng-container>

        <ng-container matColumnDef="featureType">
            <th id="resource-type" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Content Type </th>
            <td mat-cell *matCellDef="let element"> {{element.featureType | capitalizeStr}} </td>
        </ng-container>

        <ng-container matColumnDef="uploadedTime">
            <th id="resource-upload-time" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.Uploaded_Date_Time" | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.uploadedTime | date:'MM/dd/yy, hh:mm a'}} </td>
        </ng-container>

        <ng-container matColumnDef="uploadedBy">
            <th id="resource-upload-by" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.Uploaded_by" | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.uploadedBy}} </td>
        </ng-container>

        <ng-container matColumnDef="edit">
            <th id="resource-action" class="resource-header-card" mat-header-cell *matHeaderCellDef>{{ "Label.Edit" | translate}} </th>
            <td mat-cell *matCellDef="let row">
                <span class="action-control col-md-1">
                    <a matTooltip="Click to Edit" class="action-control-delete" (click)="editResource(row);">
                        <img alt="Edit" [src]="commonService.commonFiles['edit']">
                    </a>
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="delete">
            <th id="resource-action-delete" class="resource-header-card" mat-header-cell *matHeaderCellDef>{{ "Label.Delete" | translate}} </th>
            <td mat-cell *matCellDef="let row">
                <span class="action-control col-md-1">
                    <a matTooltip="Click to Delete" class="action-control-delete" (click)="deleteResource(row);">
                        <img alt="Delete" [src]="commonService.commonFiles['delete']">
                    </a>
                </span>
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


    <mat-paginator [pageSizeOptions]="[10,20]" showFirstLastButtons></mat-paginator>
</div>